export default {
    accountingToken: null,
    accountingUrl: null,
    signature: null,
    companies: [],
}
